import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';

import uswitchAward from 'assets/images/uswitch-award.svg';
import energySwitchGuarantee from 'assets/images/energy-switch-guarantee.svg';

export const testId = 'directSalesSidebarRightTestId';

export const DirectSalesSidebarRight = () => {
  return (
    <NsContent data-testid={testId}>
      <NsCard heading="You’re in safe hands" decoration="home">
        We power over 8 million homes and businesses in Britain.
      </NsCard>

      <NsCard heading="Customer service that you can rely on">
        <p>
          Uswitch Energy Awards Best Overall Improvement{' '}
          <strong>Winner 2024.</strong>
        </p>
        <img width={243} alt="uswitch award" src={uswitchAward}></img>
      </NsCard>

      <NsCard heading="Your switch can be done in as little as 3-5 days">
        <p>
          We’ve signed up to the <strong>Energy Switch Guarantee</strong>,
          making switching your energy faster, easier, and safer for you.
        </p>
        <img
          width={181}
          src={energySwitchGuarantee}
          alt="energy switch guarantee"
        />
      </NsCard>
    </NsContent>
  );
};

export default DirectSalesSidebarRight;
